import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DomainRecord as SchemaDomainRecord } from '../schemas/DomainRecord';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Удаляет запись домена
 * @tags Domains
 * @summary Удаление записи домена
 */
export const DeleteDomainRecordContentType = 'application/json' as const;
export type DeleteDomainRecordRequest = SchemaDomainRecord;
export type DeleteDomainRecordResponses = LinkCommonErrorResponses & {
    /**
     * @description Запись удалена
     */
    '200': {};
};
export type DeleteDomainRecordResponseSuccess = undefined;
export type DeleteDomainRecordSearchParams = undefined;
export type DeleteDomainRecordPathParameters = undefined;
export const DeleteDomainRecordUrl = '/domain/records' as const;
export const DeleteDomainRecordMethod = 'DELETE' as const;
export const getDeleteDomainRecordUrl = (_params?: DeleteDomainRecordPathParameters) => DeleteDomainRecordUrl;
